export default __webpack_public_path__ + "f0c0db94221c6e2f72ef643080685129.png";